import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useDeleteSickCert = () => {
  const queryClient = useQueryClient();
  const handleNetworkError = useHandleNetworkError("Error while deleting sick cert");
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (sickCert) => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.delete(
        `${tenantVal}/patientsickcert/delete`,
        { data: sickCert }
      );

      return response.data;
    },
    onSuccess: () => {
      toast.success("Sick cert deleted successfully!");
      queryClient.invalidateQueries({ queryKey: ["activeConsultationSickCert"] });
    },
    onError: handleNetworkError,
  });
};
